const divTableTitleMat = {
  option1: 'INATIVAR SELECIONADOS',
  option2: 'GERAR QRCODES',
  option3: 'ENVIAR PARA MANUTENÇÃO',
  option4: 'RETORNAR DA MANUTENÇÃO',
  option5: 'REATIVAR SELECIONADOS',
  option6: 'DELETAR SELECIONADOS',
  option7: 'CRIAR SERVIÇO EM MASSA',
  option8: 'SERVIÇOS COM ANEXOS (.ZIP)',
  tooltipBlockQRCode: 'Quando os serviços só podem ser feitos via QRCode no APP, a impressão de QRCode só está disponível para admins.',
};

export default divTableTitleMat;
